import React, { useEffect, useState } from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  useNotify,
  useRedirect,
  useUpdate,
  required,
  useDataProvider,
  AutocompleteArrayInput,
} from "react-admin";
import Box from "@mui/material/Box";
import { Descriptions } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

const DepartmentEdit: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const { id } = useParams();
  const [update] = useUpdate();

  // -----------------------------
  // 保存
  // -----------------------------
  const handleSave = async (data: any) => {
    try {
      const payload: any = {
        departmentName: data.departmentName,
        description: data.description,
      };

      await update('permissionDepartment', { id: id, data: payload });

      notify('Department updated successfully', { type: 'success' });
      redirect('list', 'permissionDepartment');
    } catch (error) {
      notify('Update failed', { type: 'error' });
    }
  };

  return (
    <Edit resource="permissionDepartment">
      <SimpleForm sx={{ backgroundColor: '#ffffff', padding: '36px' }} onSubmit={handleSave}>

        <Box display="flex" flexWrap="wrap" gap={2}>

          {/* 部门名称（一般不允许改） */}
          <Box flex="1 1 48%">
            <TextInput
              source="departmentName"
              label="Department Name"
              fullWidth
              validate={[required()]}
            />
          </Box>

          {/* 部门描述 */}
          <Box flex="1 1 48%">
            <TextInput
              source="description"
              label="Department Description"
              fullWidth
              validate={[required()]}
            />
          </Box>

        </Box>

      </SimpleForm>
    </Edit>
  );
};

export default DepartmentEdit;
